import angular, { ILogService, IOnChangesObject } from 'angular'
import { Preguntas } from 'src/_candidato/data/Preguntas'
import { NotificacionService } from '../../../../_panel/module/uni-base/services/NotifService'
import { IModelPregunta } from '../../../../model/candidato-api'
import { AccesoDatos } from '../../../comun/services/acceso-datos'
import { BloqueForm } from '../../../data/bloque-form'

class SeleccionPregsComponentCtrl implements ng.IComponentController {
  preguntas!: Preguntas
  bloque!: BloqueForm
  filterq: string = ''

  verNoSeleccionables = false

  constructor(
    //
    private $log: ILogService,
    private NotifService: NotificacionService,
    private AccesoDatos: AccesoDatos
  ) {}

  $onInit(): void {
    this.$log.info('[SeleccionPregsComponentCtrl] onInit')
  }

  $onChanges(changes: IOnChangesObject) {
    if (changes.bloque) {
      this.$log.debug('Cambio bloque formulario', changes)
    }
  }

  addPreguntaFormulario(preg: IModelPregunta) {
    this.$log.debug('add pregn to formulario', preg)

    this.bloque.nuevaPregunta(preg)
  }

  refreshQ() {
    this.AccesoDatos.EdicionFormular_CLIENT.listaPreguntas().then(
      (response) => (this.preguntas = new Preguntas(response))
    )
  }
}

angular.module('candidato').component('seleccionPregs', {
  bindings: {
    preguntas: '<',
    bloque: '<',
  },
  controller: SeleccionPregsComponentCtrl,
  template: require('./seleccion-pregs.component.html'),
  //templateUrl: "../../../../app/ui/vs/prog/dev/templates/seleccion-pregs/seleccion-pregs.component.html"
})
